// src/store/bannerSlice.js

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL1 } from "../utils/apiURL";
import { STATUS } from "../utils/status";

// État initial
const initialState = {
    banners: [],
    bannersStatus: STATUS.IDLE
}

// Slice des bannières
const bannerSlice = createSlice({
    name: 'banners',
    initialState,
    reducers: {
        clearBanners: (state) => {
            state.banners = [];
        }
    },
    extraReducers: (builder) => {
        builder
        .addCase(fetchAsyncBanners.pending, (state) => {
            state.bannersStatus = STATUS.LOADING;
        })
        .addCase(fetchAsyncBanners.fulfilled, (state, action) => {
            state.banners = action.payload;
            state.bannersStatus = STATUS.SUCCEEDED;
        })
        .addCase(fetchAsyncBanners.rejected, (state) => {
            state.bannersStatus = STATUS.FAILED;
        })
    }
});

// Action asynchrone pour récupérer les bannières
export const fetchAsyncBanners = createAsyncThunk('banners/fetch', async () => {
    const response = await fetch(`${BASE_URL1}getbanners`); // Remplacez 'x' par l'endpoint réel
    const data = await response.json();
    return data.banners;  // Assurez-vous que la réponse a cette structure
});

// Actions et sélecteurs
export const { clearBanners } = bannerSlice.actions;
export const getBanners = (state) => state.banners.banners;
export const getBannersStatus = (state) => state.banners.bannersStatus;

export default bannerSlice.reducer;
